var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('ul',{staticClass:"link-list"},_vm._l((_vm.pages),function(item,index){return _c('li',{key:index},[_c('router-link',{attrs:{"to":item.link}},[_vm._v(_vm._s(item.name))])],1)}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }